import { render, staticRenderFns } from "./TeamBonus.vue?vue&type=template&id=a3223a86&scoped=true"
import script from "./TeamBonus.vue?vue&type=script&lang=js"
export * from "./TeamBonus.vue?vue&type=script&lang=js"
import style0 from "./TeamBonus.vue?vue&type=style&index=0&id=a3223a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3223a86",
  null
  
)

export default component.exports